import {translate} from "../../../scripts/language";
import {startStars} from "../../../scripts/common-new";
import {AutoSubmitStar} from "../../../scripts/product-detail";
import {FastMessage} from "../../../scripts/fastmessages-new";
//Trida pro funkce obsluhujici ajax veci k produktum (oblibene, hlidaci pes, jednou treba porovnani?)
export const ProductRelations = {

    requestRunningFavourite: false,
    requestRunningWatchdog: false,

    //funkce volajici Ajax pro zmenu statusu oblibenosti
    changeFavouriteStatus: function (e) {
        e.preventDefault();
        e.stopPropagation();
        const context = $(this);
        if (ProductRelations.requestRunningFavourite) { // kvuli doubleclickum
            return;
        }
        const status = context.attr('data-favourited') == 'Y' ? 'N' : 'Y';

        const ajaxOpts = {
            method: "GET",
            dataType: "json",
            url: CatalogPresenter + "set-favourite-product",
            context: context,
            data: {
                productId: context.attr('data-product-id'),
                status: status
            },
            success: function (data) {
                context.attr('data-favourited', data.newStatus);
                context.toggleClass('favourited');
                //musime prenstavit i title
                let title = translate('Přidat mezi oblíbené produkty');
                let text = translate('Oblíbený produkt');
                if (context.hasClass('favourited')) {
                    title = translate('Odstranit z oblíbených produktů');
                    text = translate('Odebrat z oblíbených');
                }
                FastMessage.createMessage(data.message,FastMessage.info);
                context.attr('data-original-title', title);
                context.find('.text').text(text);
            },
            complete: function () {
                ProductRelations.requestRunningFavourite = false;
            }
        };
        ProductRelations.requestRunningFavourite = true;
        $.ajax(ajaxOpts);
        return false;
    },


    //funkce volajici Ajax pro zmenu statusu hlidacho psa
    changeWatchdogStatus: function (e) {
        e.preventDefault();
        e.stopPropagation();
        const context = $(this);
        if (ProductRelations.requestRunningWatchdog) { // kvuli doubleclickum
            return;
        }

        const status = context.attr('data-watched') == 'Y' ? 'N' : 'Y';

        const ajaxOpts = {
            method: "GET",
            dataType: "json",
            url: CatalogPresenter + "set-watchdog-product",
            context: context,
            data: {productId: context.attr('data-product-id'), status: status},
            success: function (data) {
                context.attr('data-watched', data.newStatus);
                context.toggleClass('dogwatched');

                //musime prenstavit i title
                var title = translate('Přidat mezi hlídané produkty');
                var text = translate('Hlídat produkt');
                if (context.hasClass('dogwatched')) {
                    title = translate('Odstranit z hlídaných produktů');
                    text = translate('Zrušit hlídání');
                }
                context.attr('data-original-title', title);
                context.find('.text').text(text);

                //pokud jsme pridali tento produkt do hlidanych redirecteme na sekci hlidane produkty
                if (data.newStatus == 'Y') {
                    window.location.href = CustomerPresenter + 'hlidane-produkty/';
                }

            },
            complete: function () {
                ProductRelations.requestRunningWatchdog = false;
            }
        };

        ProductRelations.requestRunningWatchdog = true;
        $.ajax(ajaxOpts);
        return false;
    },


    //odstrani polozku z listu (favourite, product), obnasi i zmenu stavu v db
    removeItemFromSection: function (context, $actionName, $productId) {
        const ajaxOpts = {
            method: "GET",
            dataType: "json",
            url: CatalogPresenter + $actionName,
            context: context,
            data: {
                productId: $productId,
                status: 'N'
            }, //chceme ho zrusit
            success: function (data) {
                //pokud jsme v sekci s přehledem hlidanych produktu tak jeste skryjeme produkt
                if (context.closest('.ProductList') && data.newStatus == 'N') {
                    if(typeof data.message != "undefined") {
                        FastMessage.createMessage(data.message, FastMessage.info);
                    }
                    context.closest('.ProductListItem').remove();
                }
            }
        };
        $.ajax(ajaxOpts);
    }
};
$(document).ready(function() {
    /*if ($('.ProductDetail')) {
        $('.ProductDetail .tabs').tabs();
    }
    $('.tabs.Directory').tabs();
    $('.tabs-search').tabs();*/

    $('.js-review').on('click',function (e) {
        e.preventDefault();
        e.stopPropagation();
        const anchor = $('[data-tab-target="tab-reviews"]');
        $('html, body').animate({
            scrollTop: anchor.offset().top
        },1000);
        anchor.trigger('click');
    });
    const productList = $('.p-product-list');
    //pridani, odebrani produktu do oblibenych z katalogu
    productList.on('click','.FavouriteProductLink', ProductRelations.changeFavouriteStatus);
    $('.c-params-detail-foot').on('click','.FavouriteProductLink', ProductRelations.changeFavouriteStatus);
    //pridani,odebrani produktu do hlidanych  z katalogu
    productList.on('click','.WatchdogProductLink', ProductRelations.changeWatchdogStatus);

    $('.ProductDetail .nextOthers').click(function(e){
        e.preventDefault();
        const $images = $(this).closest('.otherImages').find('a[data-fslightbox].hidden');
        if($images.length>0){
            $($images[0]).trigger('click');
        }
    });

    $('.ProductDetail .showPhotogallery').click(function(e){
        e.preventDefault();
        const $images = $(this).closest('.otherImages').find('a[data-fslightbox]');
        if($images.length>0){
            $($images[0]).trigger('click');
        }
    });


    //zakaznicka sekce, odebrani produktu
    $('.ProductListItem .removeFromList').on('click', function () {
        const _ = $(this);
        const productId = _.attr('data-product-id');
        const sectionType = _.attr('data-type');
        _.tooltip('hide');
        ProductRelations.removeItemFromSection(_, sectionType, productId);
    });

    productList.on('change','.storageChooser select[name=storage_id]',function (e) {
        e.preventDefault();
        e.stopPropagation();
        const storageEnable = $('.storageChooser input[name=storage_enabled]');
        storageEnable.prop('checked', true);
        if(storageEnable.is(':checked')){
            $(this).closest('form').submit();
        }
    });



    AutoSubmitStar();
    startStars();
});
